const api = {
  baseUrl: process.env.REACT_APP_BASE_API_URL,
};

export default api;
